import type { Option } from "../components/SelectFilter";
import type { DocumentCardProps } from "../types";

interface FilterDocumentsParams {
  documents: DocumentCardProps[];
  search: string;
  statusFilters: Option[];
  documentTypeFilters: Option[];
  coverageName?: string;
}

export function filterDocuments({
  documents,
  search,
  statusFilters,
  documentTypeFilters,
  coverageName,
}: FilterDocumentsParams): DocumentCardProps[] {
  const isSearchActive = search.length >= 3;

  return documents.filter((document) => {
    if (isSearchActive) {
      const searchTerm = search.toLowerCase();
      const searchableFields = [
        document.fileName.toLowerCase(),
        document.carrierName.toLowerCase(),
        document.documentType.toLowerCase(),
        document.effectiveDate?.toLowerCase() || "",
        document.plans.join(" ").toLowerCase(),
        document.status?.toLowerCase() || "",
        document.multipleLoc
          ?.map((l) => l.label)
          .join(" ")
          .toLowerCase() || "",
        document.metadata.source.toLowerCase(),
      ];

      if (coverageName) {
        searchableFields.push(coverageName.toLowerCase());
      }

      const matchesSearch = searchableFields.some((field) =>
        field.includes(searchTerm),
      );

      if (!matchesSearch) {
        return false;
      }
    }

    // Status filter — use effective visual status so the filter matches
    // what the user sees on the card (errorCode overrides status to "error").
    if (statusFilters.length > 0) {
      const statusValues = statusFilters.map((s) => s.value);
      const effectiveStatus = document.errorCode ? "error" : document.status;
      if (!effectiveStatus || !statusValues.includes(effectiveStatus)) {
        return false;
      }
    }

    // Document type filter
    if (documentTypeFilters.length > 0) {
      const documentTypeValues = documentTypeFilters.map((dt) => dt.value);
      if (!documentTypeValues.includes(document.documentType)) {
        return false;
      }
    }

    return true;
  });
}
